import Configuration from "../prototype/Configuration.js";
import Error from "../prototype/utils/Error.js";
import global from "../prototype/global.js";
import Internationalization from "../prototype/Internationalization";
import Server from "../prototype/Server.js";

const log = global.log.getLogger("f_mtac_routes.landing");
log.setLevel(log.levels.WARN);

var init = async () => {
    log.debug("landing init IN");
    global.configuration = new Configuration();
    await global.configuration.init();

    global.server = new Server();
    global.server.authentication.auto_register = false;
    await global.server.init();

    global.internationalization = new Internationalization(false);
    await global.internationalization.init();

    const enable_controls = () => {
        $("#landing_login button").prop("disabled", false);
        $("#landing_login input").prop("disabled", false);
    };

    const disable_controls = () => {
        $("#landing_login button").prop("disabled", true);
        $("#landing_login input").prop("disabled", true);
    };

    /**
     * @brief processes register and login
     *  may throw exception or forward a throw from registrar.register()
     */
    const landing_login = async (org_id, passphrase) => {
        log.debug("landing_login IN");
        if (global.server.registrar.user.token === undefined) {
            await global.server.registrar.register({passphrase, org_id});
        }
        try {
            await global.server.network.ping();
        } catch (error) {
            switch (error.status) {
                case Error.status.access:
                    await global.server.registrar.register({passphrase, org_id});
                    await global.server.authentication.auto_login();
                    break;
                default:
                    throw error;
            }
        }
        global.configuration.user.org_id = org_id;
        log.debug("move to /mtac");
        window.location.replace("/mtac");
    };

    const submit = async () => {
        disable_controls();
        const passphrase = $("#landing_login input#password").val();
        const org_id = $("#landing_login input#organization").val();
        try {
            await landing_login(org_id, passphrase);
        } catch (error) {
            log.debug("error ",error);
            enable_controls();
            if (error.data?.code == 70001) {
                // see APR_TACTEAM_MAX_DEVICES_REACHED on server side
                $("#landing_login #error_message").text(global.internationalization.text("startup.Max-device-nb-reached-Contact-support"));
                return;
            }
            switch (error.status) {
                case Error.status.access:
                case Error.status.invalid:
                    $("#landing_login #error_message").text(global.internationalization.text("startup.Invalid-inputs"));
                    break;
                default:
                    $("#landing_login #error_message").text(error.message);
            }
            return;
        }
    };

    $("body").on("click", "#landing_login button", async () => {
        submit();
    });

    $("body").on("keydown", "#landing_login input", async (event) => {
        $("#landing_login #error_message").text("");
        if (event.key === "Enter") {
            event.preventDefault();
            submit();
        }
    });

    if (global.server.registrar.user.token === undefined) {
        enable_controls();
        return;
    }

    try {
        await global.server.network.ping();
        log.debug("move to /mtac");
        window.location.replace("/mtac");
    } catch (error) {
        enable_controls();
    }
};
var finalize = () => {};

export default {init, finalize};
